import React, { useState, useEffect, useRef, useCallback } from "react";
import { Icon, Form } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import * as yup from "yup";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import TextEditor from "../../../../components/Admin/TextEditor";

import { Container, Title, Button, Field, Input, Label } from "./styled";

import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
toast.configure();

const EditarEmail = (props) => {
  const text = useRef("");
  const [email, setEmail] = useState({});
  const [remetenteNome, setRemetenteNome] = useState("");
  const [remetenteEmail, setRemetenteEmail] = useState("");
  const { id } = props.match.params;
  useEffect(() => {
    loadAuth();
    api
      .get(`admin/email?id=${id}`)
      .then(async (res) => {
        setEmail(res.data);
        let array = { local: "emails", texto: `listou o email de id=${id}` };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        const remetenteValue = res.data.remetente.split(":");
        setRemetenteNome(remetenteValue[0]);
        setRemetenteEmail(remetenteValue[1]);
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Erro ao Editar",
          "Por favor, verifique se esse email realmente existe",
          "error"
        );
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const handleSubmit = async () => {
    const EmailValidation = yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo do email")
        .required("Necessário que informe o titulo do email"),
      assunto: yup
        .string("Necessário que informe o assunto do email")
        .required("Necessário que informe o assunto do email"),
    });

    try {
      await EmailValidation.validate(email, { abortEarly: true });
      const payload = {
        titulo: email.titulo,
        assunto: email.assunto,
        remetente: remetenteNome + ": " + remetenteEmail,
        conteudo: text.current,
      };
      await api
        .put(`admin/email/${id}`, payload)
        .then(async (res) => {
          let array = { local: "emails", texto: `editou o email de id= ${id}` };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Sucesso!", "Edição bem sucedida", "success");
        })
        .catch((err) => {
          console.error(err);
          swal(
            "Erro ao Editar",
            "Por favor, preencha todos os campos necessários",
            "error"
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <AdminMenu />

      <Container>
        <Title>Criar Modelo de E-mail</Title>
        <Form>
          <Field>
            <Label>Titulo</Label>
            <Input
              type="text"
              placeholder="Titulo"
              name="titulo"
              value={email.titulo}
              onChange={(e) => setEmail({ ...email, titulo: e.target.value })}
            />
          </Field>

          <Field>
            <Label>Assunto</Label>
            <Input
              type="text"
              placeholder="Assunto"
              name="assunto"
              value={email.assunto}
              onChange={(e) => {
                setEmail({ ...email, assunto: e.target.value });
              }}
            />
          </Field>

          <Form.Group widths="equal">
            <Field style={{ padding: 2 }}>
              <Label>Nome do Remetente</Label>
              <Input
                type="text"
                placeholder="Nome do Remetente"
                name="remetente"
                value={remetenteNome}
                onChange={(e) => setRemetenteNome(e.target.value)}
              />
            </Field>

            <Field style={{ padding: 2 }}>
              <Label>Responder para ou E-mail do Remetente</Label>
              <Input
                type="text"
                placeholder="remetente@voitto.com.br"
                name="assunto"
                value={remetenteEmail}
                onChange={(e) => setRemetenteEmail(e.target.value)}
              />
            </Field>
          </Form.Group>

          <Field className="container media">
            <Label>Conteúdo</Label>
            <TextEditor text={text} default={email.conteudo} />
          </Field>

          <Button type="submit" onClick={handleSubmit}>
            <Icon name="save" />
            Salvar
          </Button>
        </Form>
      </Container>
    </>
  );
};
export default EditarEmail;
